import React, { useState } from 'react';
import { Button, Text, TextArea, View } from 'native-base';
import { Modal } from 'react-native';
import EStyleSheet from 'react-native-extended-stylesheet';
import { TEXT_FIELD_MAX_LENGTH } from '../../helpers/constants';

function RejectCateringDraftOrderModal({ visible, onConfirm, onCancel }) {
  const [reason, setReason] = useState('');

  const handleClose = () => {
    setReason('');
    onCancel();
  };

  const handleConfirm = () => {
    const trimmedReason = reason.trim();
    setReason('');
    onConfirm(trimmedReason);
  };

  return (
    <Modal
      visible={visible}
      transparent
      animationType="fade"
      onRequestClose={handleClose}
    >
      <View style={styles.overlay}>
        <View style={styles.container}>
          <Text style={styles.title}>Reject Catering Draft Order</Text>
          <Text style={styles.subtitle}>
            The customer will be notified and their order will be cancelled.
          </Text>
          <TextArea
            placeholder="Reason for rejection (optional)"
            value={reason}
            onChangeText={setReason}
            maxLength={TEXT_FIELD_MAX_LENGTH}
            rowSpan={3}
            style={styles.textArea}
          />
          <View style={styles.buttonRow}>
            <Button
              variant="ghost"
              onPress={handleClose}
            >
              <Text>Cancel</Text>
            </Button>
            <Button
              colorScheme="danger"
              onPress={handleConfirm}
              style={styles.rejectButton}
            >
              <Text style={styles.rejectButtonText}>Reject</Text>
            </Button>
          </View>
        </View>
      </View>
    </Modal>
  );
}

const styles = EStyleSheet.create({
  overlay: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
  },
  container: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 20,
    width: '80%',
    maxWidth: 400,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  subtitle: {
    marginBottom: 12,
  },
  textArea: {
    marginBottom: 16,
  },
  buttonRow: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  rejectButton: {
    marginLeft: 8,
  },
  rejectButtonText: {
    color: '#fff',
  },
});

export default RejectCateringDraftOrderModal;
